import { render, staticRenderFns } from "./taxPayerSystem.vue?vue&type=template&id=b5410b8a&scoped=true&"
import script from "./taxPayerSystem.vue?vue&type=script&lang=js&"
export * from "./taxPayerSystem.vue?vue&type=script&lang=js&"
import style0 from "./taxPayerSystem.vue?vue&type=style&index=0&id=b5410b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5410b8a",
  null
  
)

export default component.exports